export default __webpack_public_path__ + "/dist/images/search-icon.f9fd723f214c64b2c5c71e29d737f765.svg";